import React, { useEffect } from 'react';
import './OrderSuccessOverlay.scss';
import { useRouter } from '../../../hooks/router';
import { XOverlay } from '../../x/overlay/XOverlay';
import { Environment } from '../../../environment';

interface Props {
    redirectTo: any;
}

export function OrderSuccessOverlay({ redirectTo }: Props) {
    const { push } = useRouter();

    useEffect(() => {
        setTimeout(
            () => {
                push(redirectTo);
            },
            Environment.isE2e() ? 0 : 2000,
        );

        return () => clearTimeout();
    }, [redirectTo]);

    return (
        <>
            <XOverlay type="success" title="Order placed!" description="You will be redirected in a few seconds" />
        </>
    );
}
